import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './LinkSlatePlugin.scss'
import * as LinkUtils from './LinkUtils'
import { FaTrash, FaFile } from 'react-icons/lib/fa'
import { ButtonGroup, Button } from 'reactstrap'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import LinkModal from './LinkModal'
import EditorTooltip from '../EditorTooltip'

const { getLink, unlink } = LinkUtils

class LinkNode extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isFile: props.node.data.get('isFile'),
      isOpenModal: props.node.data.get('openModal'),
      mounted: false,
      presetData: {
        text: props.node.data.get('title') || ''
      },
      pageId: props.editor.props.pageId,
      parentId: props.editor.props.parentId
    }
    this.uid = Date.now()
  }

  modal = (isOpenModal) => {
    const _state = { isOpenModal }
    if (isOpenModal) {
      _state.presetData = { text: this.text && this.text.innerText }
    }
    this.setState(_state)
  }

  componentDidMount () {
    this.setState({
      mounted: true
    })

    this.setLinkTextFromEditorValue()
  }

  setLinkTextFromEditorValue = () => {
    if (this.text) {
      this.setState({
        presetData: { text: this.text.innerText }
      })
    }
  }

  onChangeTextByEditor = (props, state) => {
    // inner text changed by editor
    if (state.mounted && state.presetData.text !== this.text.innerText) {
      this.setLinkTextFromEditorValue()
    }
  }

  componentWillUpdate (props, state) {
    // inner text changed by modal
    const nextText = props.node.data.get('text')
    const prevText = this.props.node.data.get('text')
    if (nextText !== prevText) {
      return this.setState({
        presetData: { text: nextText }
      })
    }

    this.onChangeTextByEditor(props, state)
  }

  getRef = text => {
    if (text) {
      this.text = text
    }
  }

  render () {
    const { isOpenModal, presetData, pageId, parentId } = this.state
    const { children, attributes, state, node, readOnly, editor: { onChange } } = this.props

    const isInternalLink = node.data.get('isInternalLink')
    const isFile = node.data.get('isFile')
    const focusedOnCurrentNode = getLink(state) && node.key === getLink(state).key
    const showTooltip = !readOnly && state.isCollapsed && focusedOnCurrentNode
    const isDeadLink = node.data.get('href') === '#'

    const isInvalidFile = node.data.get('href') && node.data.get('href').indexOf('s3.amazonaws.com') > -1 &&
      !node.data.get('fileId')

    return (
      <span>
        <LinkModal
          pageId={pageId}
          parentId={parentId}
          isOpen={isOpenModal}
          node={node}
          state={state}
          onChange={onChange}
          changeModalState={this.modal}
          presetData={presetData}
          />

        <EditorTooltip state={state} placement='top' isOpen={showTooltip && !isOpenModal} target={'link-node-container' + this.uid} toggle={this.toggle}>
          <div>
            <div>
              {isInternalLink
                ? <div>
                  <div>Internal page:</div>
                  <Link to={`/pages/edit/${node.data.get('pageId')}`}>
                    {`✨ ${node.data.get('href')}`}
                  </Link>
                </div>
                : isFile
                ? <div>
                  <a href={node.data.get('href')} title={node.data.get('href')}
                    target='_blank'>
                    <FaFile fill='white' />
                    <div>{this.state.presetData.text}</div>
                  </a>
                </div>
                : <div>
                  <a href={node.data.get('href')} title={node.data.get('href')}
                    target='_blank'>
                    {node.data.get('href')}
                  </a>
                </div>
              }
            </div>

            <ButtonGroup style={{marginTop: '10px'}}>
              <Button onClick={() => this.modal(true)}>
                Edit
              </Button>
              <Button color='danger' onClick={() => onChange(unlink(state))}>
                <FaTrash />
              </Button>
            </ButtonGroup>
          </div>
        </EditorTooltip>

        <span id={'link-node-container' + this.uid} className='link-node-container' style={{color: '#0275d8'}}>
          <a
            {...attributes}
            className={classNames(
              styles.linkStyle,
              styles['linkStyle-' + (node.data.get('linkStyle') || 'default')],
              {
                [styles.fileLink]: isFile,
                [styles.internalLink]: isInternalLink,
                [styles.deadLink]: isDeadLink,
                [styles.invalidFile]: isInvalidFile
              }
            )}
            href={node.data.get('href')}
            target={node.data.get('target')}
            title={node.data.get('title')}
            ref={this.getRef}
          >
            {children}
          </a>
        </span>
      </span>
    )
  }
}

LinkNode.propTypes = {
  node: PropTypes.object,
  attributes: PropTypes.object,
  children: PropTypes.node,
  state: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
  editor: PropTypes.object.isRequired
}

export default LinkNode



// WEBPACK FOOTER //
// ./src/components/LinkSlatePlugin/LinkNode.js